/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreRss = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.557 9.987a8.641 8.641 0 0 0-1.281-3.144 8.872 8.872 0 0 0-2.493-2.492 8.842 8.842 0 0 0-1.523-.803 8.755 8.755 0 0 0-1.622-.48 8.896 8.896 0 0 0-3.341 0 .5.5 0 0 0 .189.982 7.848 7.848 0 0 1 2.962 0 7.75 7.75 0 0 1 1.435.425 7.763 7.763 0 0 1 4.692 5.703 7.855 7.855 0 0 1 0 2.961.5.5 0 0 0 .982.19 8.777 8.777 0 0 0 0-3.341zM7.467 11.658a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
    />
    <path
      fill="currentColor"
      d="M10.296 9.495a5.626 5.626 0 0 0-.527-1.001 5.825 5.825 0 0 0-1.638-1.639 5.815 5.815 0 0 0-1-.526 5.824 5.824 0 0 0-3.26-.315.5.5 0 0 0 .188.982 4.793 4.793 0 0 1 2.695.26A4.787 4.787 0 0 1 8.325 8.3a4.719 4.719 0 0 1 1.393 3.359c0 .304-.029.609-.087.908a.5.5 0 0 0 .981.19 5.778 5.778 0 0 0-.316-3.261z"
    />
  </svg>
);

IconCoreRss.displayName = 'IconCoreRss';

IconCoreRss.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreRss);
IconCoreRss.displayName = 'IconCoreRss';
